import { createUseStyles } from "react-jss";
import { controlBackgroundColor, foregroundColor } from "../../theme/Mixins";

export default createUseStyles((theme: any) => ({
    scrollbars: {
        composes: "scrollbars",

        /* Override overflow from react-custom-scrollbars to allow overflow for dropdowns */
        overflow: "visible !important",
    },
    scrollable: {
        composes: "scrollable",
        margin: [[0, -29]],
        position: "relative",
    },
    scrollableWindow: {
        composes: "scrollable__window",
        display: "flex",
    },
    scrollTrackHorizontal: {
        left: 29,
        right: 29,
        zIndex: 99,
        bottom: 0,
        height: "16px !important",
        transition: "opacity 200ms",
    },
    scrollTrackHorizontalHidden: {
        opacity: 0,
    },
    scrollThumbHorizontal: {
        borderRadius: 3,
        background: theme.ControlBorderColor,
        height: "6px !important",
        top: 5,
        transition: "height 100ms, border-radius 100ms, top 100ms",
    },
    scrollThumbHorizontalActive: {
        borderRadius: 8,
        top: 0,
        height: "16px !important",
    },
    scrollableChild: {
        composes: "scrollable__child",
        width: "100%",
        padding: [[0, 29]],
    },
    indicator: {
        composes: "scrollable__scroll-indicator",
        background: theme.ControlBackground,
        color: foregroundColor(theme, theme.ControlBackground),
        display: "inline-flex",
        alignItems: "center",
        justifyContent: "center",
        position: "absolute",
        margin: [[0, -29]],
        top: 14.5,
        bottom: 29,
        width: 29,
        transition: "opacity 100ms, background 100ms, color 100ms",
        cursor: "pointer",
        userSelect: "none",
        zIndex: 99,
    },
    indicatorLeft: {
        composes: "scrollable__scroll-indicator--left",
        left: 29,
        borderTopRightRadius: 15,
        borderBottomRightRadius: 15,
    },
    indicatorRight: {
        composes: "scrollable__scroll-indicator--right",
        right: 29,
        borderTopLeftRadius: 15,
        borderBottomLeftRadius: 15,
    },
    indicatorHidden: {
        composes: "scrollable__scroll-indicator--hidden",
        opacity: 0,
    },
    icon: {
        composes: "scrollable__scroll-indicator__icon",
        color: foregroundColor(theme, controlBackgroundColor(theme)),
    },
}));
